import Header from '@/components/landing/layout/Header';
import Footer from '@/components/landing/layout/Footer';

const Terms = () => {
  return (
    <>
      <div className="tw-flex tw-flex-col tw-min-h-screen">
        <Header />
        <main className="tw-flex-grow tw-pt-24 tw-pb-16">
          <div className="tw-container tw-mx-auto tw-px-4">
            <div className="tw-max-w-4xl tw-mx-auto">
              <h1 className="tw-text-3xl tw-font-bold tw-mb-8">Terms of Service</h1>

              <div className="tw-prose tw-prose-lg">
                <p className="tw-mb-4">
                  Last Updated:{' '}
                  {new Date().toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric',
                  })}
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">1. Introduction</h2>
                <p>
                  Welcome to Protega.ai. By accessing or using our services, you agree to be bound
                  by these Terms of Service. Please read them carefully.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">2. Definitions</h2>
                <p>Throughout these Terms of Service:</p>
                <ul className="tw-list-disc tw-pl-6 tw-mb-4">
                  <li>"Protega.ai", "we", "us", or "our" refers to Protega.ai and its affiliates.</li>
                  <li>
                    "Service" or "Services" refers to the applications, features, and products
                    provided by Protega.ai.
                  </li>
                  <li>"You" or "your" refers to the individual or entity using our Services.</li>
                </ul>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">3. Use of Services</h2>
                <p>
                  Our Services are provided for your personal or business use. You may not modify,
                  copy, distribute, transmit, display, perform, reproduce, publish, license, create
                  derivative works from, transfer, or sell any information, software, products, or
                  services obtained from our Services without our prior written permission.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">4. User Accounts</h2>
                <p>
                  To access certain features of our Services, you may need to create an account. You
                  are responsible for maintaining the confidentiality of your account information
                  and for all activities that occur under your account.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">5. Privacy</h2>
                <p>
                  Your privacy is important to us. Please review our Privacy Policy to understand
                  how we collect, use, and disclose information about you.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">
                  6. Intellectual Property
                </h2>
                <p>
                  All content, features, and functionality of our Services, including but not
                  limited to text, graphics, logos, icons, images, audio clips, digital downloads,
                  data compilations, and software, are the exclusive property of Protega.ai or its
                  licensors.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">
                  7. Disclaimer of Warranties
                </h2>
                <p>
                  Our Services are provided "as is" and "as available" without warranties of any
                  kind, either express or implied, including, but not limited to, implied warranties
                  of merchantability, fitness for a particular purpose, or non-infringement.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">
                  8. Limitation of Liability
                </h2>
                <p>
                  To the fullest extent permitted by applicable law, Protega.ai shall not be liable
                  for any indirect, incidental, special, consequential, or punitive damages, or any
                  loss of profits or revenues, whether incurred directly or indirectly, or any loss
                  of data, use, goodwill, or other intangible losses, resulting from your access to
                  or use of or inability to access or use the services.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">9. Governing Law</h2>
                <p>
                  These Terms of Service shall be governed by and construed in accordance with the
                  laws of India, without regard to its conflict of law principles.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">
                  10. Changes to Terms
                </h2>
                <p>
                  We reserve the right to modify these Terms of Service at any time. If we make
                  changes, we will provide notice by posting the updated terms on our website and
                  updating the "Last Updated" date at the top.
                </p>

                <h2 className="tw-text-xl tw-font-semibold tw-mt-8 tw-mb-4">11. Contact Us</h2>
                <p>
                  If you have any questions about these Terms of Service, please contact us at{' '}
                  <a href="mailto:corp@protega.ai">corp@protega.ai</a>.
                </p>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Terms;
